import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicApp from './pages/public/PublicApp';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { Authenticator, Image, Text, View, ThemeProvider, createTheme, useTheme, Theme, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { signIn } from './services/authService';
import { fetchAuthSession } from 'aws-amplify/auth';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

const currentConfig = Amplify.getConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));

const isPublicFeedbackRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/f/');

// Create a custom Amplify UI theme
const customTheme = createTheme({
  name: 'custom-theme',
  tokens: {
    colors: {
      brand: {
        primary: {
          '10': '#efe8ff',
          '80': '#7B08EF',
          '90': '#5e06b8',
        },
      },
    },
    components: {
      button: {
        primary: {
          backgroundColor: '#7B08EF',
        },
        link: {
          color: '#7B08EF',
        },
      },
      fieldcontrol: {
        _focus: {
          boxShadow: '0 0 0 2px #7B08EF',
        },
      },
      tabs: {
        item: {
          color: '#ffffff',
          _active: {
            borderColor: '#7B08EF',
            color: '#7B08EF',
          },
        },
      },
    },
  },
});
const component = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image
          alt="Amplify logo"
          src="https://docs.amplify.aws/assets/logo-dark.svg"
        />
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>
          &copy; All Rights Reserved
        </Text>
      </View>
    );
  },

  // ✅ THIS is what centers the Authenticator form
  Container({ children }) {
    return (
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f9f9f9',
        }}
      >
        {children}
      </div>
    );
  }
}

const getAccessToken = async () => {
  try {
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();
  const idToken = session.tokens?.idToken?.toString();

  // Store both tokens in case different services expect different JWTs
  if (accessToken) {
    localStorage.setItem("token", accessToken);
    console.log("Stored auth access token (first 10 chars):", accessToken.slice(0, 10));
  }
  if (idToken) {
    localStorage.setItem("idToken", idToken);
    console.log("Stored auth id token (first 10 chars):", idToken.slice(0, 10));
  }

  if (!accessToken && !idToken) {
    console.warn("No auth tokens returned by fetchAuthSession().");
  }
  } catch (err) {
    //console.error("❌ Failed to get token:", err);
  }
};

if (isPublicFeedbackRoute) {
  root.render(
    <React.StrictMode>
      <PublicApp />
    </React.StrictMode>
  );
} else {
  root.render(
    // <React.StrictMode>
    //   <Provider store={store}>
    //     <PersistGate loading={<div>Loading persisted state...</div>} persistor={persistor}>
    //       <App />
    //     </PersistGate>
    //   </Provider>
    // </React.StrictMode>

    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={customTheme}>
          {/* <div style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            //background: 'linear-gradient(135deg, #7B08EF, #77068A)'
          }}> */}
          <Authenticator loginMechanisms={['email']} hideSignUp={true} components={component}>
            {({ signOut, user }) => {
              //console.log("User Details: ", user);
              getAccessToken();
              return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <App signout={signOut} user={user} />
                </LocalizationProvider>
              )
            }}
          </Authenticator>
          {/* </div> */}
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
}
